export default {
    rootViewStyle: {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100vw',
        height: '100vh',
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, .6)',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    containerViewStyle: {
        position: 'relative',
        width: '92.27vw',
        backgroundColor: '#FFFFFF',
        borderRadius: '4.93vw'
    },
    titleTextStyle: {
        marginTop: '9.33vw',
        fontSize: '5.2vw',
        fontWeight: 'bold',
        color: '#535353',
    },
    contentTextStyle: {
        width: '83.2vw',
        lineHeight: '6.93vw',
        margin: '10.27vw auto 8vw',
        boxSizing: 'content-box',
        textAlign: 'center',
        fontSize: '4.8vw',
        fontWeight: 'bold',
        color: '#535353',
    },
    btnImgStyle: {
        width: '89.6vw',
        height: '19.87vw',
        marginBottom: '3.2vw',
    },
    closeBtnImgStyle: {
        position: 'absolute',
        bottom: '3.2vw',
        right: '3.73vw',
        width: '26vw',
        height: '14.13vw'
    }
};
